import { BookmarkModel } from './bookmark.model';
import { isNil } from 'lodash';

export abstract class SortModel<T> {
    label: string;
    fields: (keyof T)[];
    ascending: boolean;
}

export class BookmarkSortModel extends SortModel<BookmarkModel> {
}

export function getModelValue<T>(model: T, fieldNames: (keyof T)[], fieldValueAscending: boolean): T[keyof T] {
    const values = fieldNames
        // get field value
        .map((field) => model[field])
        // trim nil values: undefined | null
        .filter((value) => !isNil(value));

    if (fieldValueAscending) { // ascending: get first value
        return values
            .sort()
            .shift();
    } else { // descending: get last value
        return values
            .sort()
            .pop();
    }
}

export function sortModels<T>(models: T[], fieldNames: (keyof T)[], ascending: boolean): T[] {
    if (fieldNames.length === 0) {
        return models;
    }

    const collator = new Intl.Collator('en-US', { sensitivity: 'base' });

    return models.sort((a, b) => {
        const aValue = getModelValue(a, fieldNames, ascending) || '';
        const bValue = getModelValue(b, fieldNames, ascending) || '';

        return ((ascending) ? 1 : -1) * collator.compare(aValue.toString(), bValue.toString());
    });
}

